import React from "react";
import { COMPONENT_TYPES } from "@/helpers/constants";
import BannerWithImage from "@/components/PagePiller/components/BannerWithImage";
import ClusterListComponent from "@/components/PagePiller/components/ClusterList";
import VideoWidgetComponent from "@/components/PagePiller/components/VideoWidget";
import ContentImageDescComponent from "@/components/PagePiller/components/ContentImageDesc";
import ClusterActionCardsComponent from "@/components/PagePiller/components/ClusterActionCards";
import ContentDescriptionComponent from "@/components/PagePiller/components/ContentDescription";
import TopTipsComponent from "@/components/PagePiller/components/TopTips";
import FAQComponent from "@/components/FAQ";
import ArticleComponent from "@/components/ArticleComponent";
import ArticlesByTagComponent from "@/components/PagePiller/components/ArticlesByTag";
import PageIndex from "@/components/PagePiller/components/PageIndex";
import ShoppingComponent from "@/components/ShoppingComponent";

interface ComponentMappingProps {
  data: any;
  extras?: { [key: string]: any };
}

const componentMapping = (props: ComponentMappingProps): React.ReactElement => {
  const { data, extras = {} } = props;
  const { userAgent, userOnBoarded, registerRef, elementRefs, indexContent, productInfo } = extras;
  const type = data.ComponentType;

  switch (type) {
    case COMPONENT_TYPES.Index:
      return <PageIndex data={indexContent} elementRefs={elementRefs} userAgent={userAgent} />;
    case COMPONENT_TYPES.BannerWithCard:
      return <BannerWithImage data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ClusterList:
      return <ClusterListComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.VideoWidget1:
      return <VideoWidgetComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ContentImageDesc:
      return <ContentImageDescComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ClusterActionCards:
      return <ClusterActionCardsComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.ArticlesByTag:
      return (
        <ArticlesByTagComponent
          data={data}
          userAgent={userAgent}
          registerRef={registerRef}
          categorySlug={extras?.categorySlug}
        />
      );

    case COMPONENT_TYPES.ArticlesWithTagSlider:
      const articleData = {
        articles: data?.ArticlesList,
        ...data,
      };

      // TODO: need to add ctaURL: Now the user will see the view all articles button, which will help user to land on the particular article listing page related to particular product category which is tagged under the current pillar page (eg: upon clicking the view all articles button in the default stage, the user will land on the article listing page of diet under the trimester 1 pillar)
      return (
        <ArticleComponent
          data={articleData}
          userAgent={userAgent}
          categorySlug={extras?.categorySlug}
          pillarSlug={extras?.pillarSlug}
          registerRef={registerRef}
          desktopItems={2}
        />
      );
    case COMPONENT_TYPES.ContentDescription:
      return (
        <section
          data-ref_id={data?.refId}
          ref={(el) => {
            if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
          }}
          className={"container scrollMargin spacingBetweenSections"}
        >
          <ContentDescriptionComponent data={data?.Description} userAgent={userAgent} />
        </section>
      );
    case COMPONENT_TYPES.TopTips:
      return <TopTipsComponent data={data} userAgent={userAgent} registerRef={registerRef} />;
    case COMPONENT_TYPES.FaqListWithTitle:
      return <FAQComponent data={data} />;
    case COMPONENT_TYPES.ShopByCatSlider:
      return <ShoppingComponent data={data} productInfo={productInfo} userAgent={userAgent} />;
    default:
      // return undefined;

      return <></>;
  }
};

export default componentMapping;
